import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BACKEND_API_URL } from '@shared/core';
import { select, Store } from '@ngrx/store';
import { from, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { getLayoutScopeId } from '../selectors';

/** Stamps every request to our own backend with the org scope (e.g. "CEM") the frontend
 *  resolved in scope.ts, so backend functions don't have to re-derive it from Origin/Referer. */
@Injectable()
export class ScopeInterceptor implements HttpInterceptor {
	constructor(
		private store: Store<any>,
		private afAuth: AngularFireAuth,
		@Inject(BACKEND_API_URL) private backendApiUrl: string
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!req.url.startsWith(this.backendApiUrl)) {
			return next.handle(req);
		}

		return this.afAuth.authState.pipe(
			take(1),
			switchMap(user => {
				return from(user.getIdToken()).pipe(
					switchMap(idToken =>
						this.store.pipe(
							select(getLayoutScopeId),
							take(1),
							switchMap(scope => {
								const request = scope
									? req.clone({
											setHeaders: {
												'X-Spaq-Scope': scope,
												Authorization: `Bearer ${idToken}`
											}
										})
									: req;

								return next.handle(request);
							})
						)
					)
				);
			})
		);
	}
}
